module.exports = __webpack_public_path__ + "static/media/Bitmap@2x.5cb6175b.png";